import styled from 'styled-components';
import CancelBlueSvg from '../../assets/mytrips/cancel-blue.svg';

const CancelBlueIcon = styled(CancelBlueSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CancelBlueIcon;
